export const IPERMIT_MODULES = {
  INSPECTION: 'inspection',
  PERMIT: 'permit',
  HERS: 'hers',
  SCHEDULING: 'scheduling',
  SCHED_CALENDAR: 'sched_calendar',
  MAILING: 'mailing',
  FINANCE: 'accounting',
  ALL_JOBS: 'all_jobs',
  CONTRACTOR_JOBS: 'contractor_jobs',
  CF1R: 'cf1r',
  COMPANIES: 'companies',
  ALL_COMPANIES: 'all_companies',
  CONTRACTOR_USERS: 'contractor_users',
  ADMIN: 'admin',
  NOT_SYNCED_TO_CRM: 'not_synced_to_crm',
};
